import httpApiApplication from 'app/http/httpApiApplication';
import { type CatalogModel } from '../modules/configuration/catalogs/models/Catalog';

export const getSystemMessage = (code: string): Promise<CatalogModel> => {
  return httpApiApplication.get<CatalogModel>(`/catalog-values/system-message/${code}`, {
    headers: { lang: true }
  });
};
